The specific organization to which the person held positions.
